import { useContext } from 'react';
import { faEnvelope, faMobile } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BranchFormValues } from 'assets/js/pages/engage/workflows/actions/types';
import { ParentMessageContext } from 'assets/js/pages/engage/workflows/components/ParentMessageProvider';
import { WorkflowActionTypeEnum } from 'constants/workflows';

interface BranchMessageDisplayValueProps {
    value: BranchFormValues['value'];
}
const BranchMessageDisplayValue = ({ value }: BranchMessageDisplayValueProps) => {
    const { messageOptions } = useContext(ParentMessageContext);
    if (!value || 'messages' in value === false) return null;
    const message = messageOptions.find(m => value.messages.includes(m.id));

    if (!message) return null;

    const icon = message.type === WorkflowActionTypeEnum.SEND_EMAIL ? faEnvelope : faMobile;
    const heading = message.type === WorkflowActionTypeEnum.SEND_EMAIL ? 'Email' : 'SMS';

    return (
        <div className="flex gap-2 rounded-lg border border-gray-200 p-3 px-4">
            <FontAwesomeIcon icon={icon} className="py-1 text-green-500" />
            <div className="flex flex-col">
                <p className="font-medium">{heading}</p>
                <p className="text-sm text-gray-500">{message.label}</p>
            </div>
        </div>
    );
};

export { BranchMessageDisplayValue };
